import "./ModelAccuracyGradient.scss";
import React from "react";

export const ModelAccuracyGradient: React.FC = () => {
  return (
    <>
      <div className="modelAccuracyGradientContainer">
        <div className="gradientTitle">
          <div>Model Accuracy</div>
        </div>
        <div className="gradientBar">
          <div className="tick tickHigh"></div>
          <div className="label labelHigh">High</div>
          <div className="tick tickMid"></div>
          <div className="label labelMid">Median</div>
          <div className="tick tickLow"></div>
          <div className="label labelLow">Low</div>
        </div>
      </div>
      <div className="dmaNoteHolder">
        <div className="dmaNote">
          <div className="blankRectangle"></div>
          <div className="dmaNoteText">Not included in model training</div>
        </div>
      </div>
    </>
  );
};

export default ModelAccuracyGradient;
